<template>
  <div class="container-fluid">
    <div class="row mb-3 no-print">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-center">
          <p class="lead m-0">Plano de Ação - Detalhamento</p>
        </div>
      </div>
    </div>

    <div class="row mb-3 no-print">
      <div class="col-12">
        <router-link
          to="/action-plan/form"
          class="btn btn-success"
        >
          <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon>
          Voltar ao Plano de Ação
        </router-link>

        <button
          @click="print"
          class="btn btn-primary ml-2"
        >
          <font-awesome-icon :icon="['fas', 'print']"></font-awesome-icon>
          Salvar / Imprimir
        </button>
      </div>
    </div>

    <div class="form-item-holder mb-3 break-after">
      <form-item
        ref="uploaded-items"
        :risk-analysis="riskAnalysis"
        :index="1"
      ></form-item>
      <div class="loading-panel" v-if="loading">
        <ProgressSpinner />
      </div>
    </div>

    <div class="row mb-3 form" v-if="services?.includes('signaling')">
      <div class="col-12 col-md-12">
        <SignalingForm
          :riskAnalysisDescriptionId="riskAnalysis.id"
          :printing="true"
        >
        </SignalingForm>
      </div>
    </div>

    <div class="row mb-3 form" v-if="services?.includes('boilermaking_locksmithing')">
      <div class="col-12 col-md-12">
        <BoilermakingForm
          :riskAnalysisDescriptionId="riskAnalysis.id"
          :printing="true"
        >
        </BoilermakingForm>
      </div>
    </div>

    <div class="row mb-3 form" v-if="services?.includes('construction_layout')">
      <div class="col-12 col-md-12">
        <ConstructionForm
          :riskAnalysisDescriptionId="riskAnalysis.id"
          :printing="true"
        >
        </ConstructionForm>
      </div>
    </div>

    <div class="row mb-3 form" v-if="services?.includes('security_devices')">
      <div class="col-12 col-md-12">
        <SecurityDevicesForm
          :riskAnalysisDescriptionId="riskAnalysis.id"
          :printing="true"
        >
        </SecurityDevicesForm>
      </div>
    </div>

    <div class="row mb-3 form" v-if="services?.includes('electric')">
      <div class="col-12 col-md-12">
        <ElectricForm
          :riskAnalysisDescriptionId="riskAnalysis.id"
          :printing="true"
        >
        </ElectricForm>
      </div>
    </div>

    <div class="row mb-3 form" v-if="services?.includes('painting')">
      <div class="col-12 col-md-12">
        <PaintingForm
          :riskAnalysisDescriptionId="riskAnalysis.id"
          :printing="true"
        >
        </PaintingForm>
      </div>
    </div>

    <div class="row mb-3" v-if="services?.length > 0">
      <div class="col-12 col-md-12">
        <DifficultiesForm
          :riskAnalysisDescriptionId="riskAnalysis.id"
          :printing="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { useRoute } from 'vue-router'
  import useSwal from '@/modules/Swal.js'

  import ProgressSpinner from 'primevue/progressspinner'
  import FormItem from '../components/FormItem'
  
  import SignalingForm from '../adequacy_forms/SingnalingForm'
  import BoilermakingForm from '../adequacy_forms/BoilermakingForm'
  import ConstructionForm from '../adequacy_forms/ConstructionForm'
  import SecurityDevicesForm from '../adequacy_forms/SecurityDevicesForm'
  import ElectricForm from '../adequacy_forms/ElectricForm'
  import PaintingForm from '../adequacy_forms/PaintingForm'
  import DifficultiesForm from '../adequacy_forms/components/DifficultiesForm'

  export default {
    setup() {
      const { showConfirmationDialog } = useSwal()
      const { showConfirmDeletionSwal } = useSwal()
      const { showSuccessDialog } = useSwal()
      
      const { params } = useRoute()

      const riskAnalysisDescriptionId = params.riskAnalysisDescriptionId

      return {
        riskAnalysisDescriptionId,
        showConfirmationDialog,
        showConfirmDeletionSwal,
        showSuccessDialog,
      }
    },
    components: {
      FormItem,
      ProgressSpinner,
      SignalingForm,
      BoilermakingForm,
      ConstructionForm,
      SecurityDevicesForm,
      ElectricForm,
      PaintingForm,
      DifficultiesForm,
    },
    data() {
      return {
        loading: false,
        riskAnalysis: {},
        services: [],
      }
    },
    methods: {
      load() {
        this.loading = true

        this.axios
          .get(
            `/api/action-plan/get-risk-analysis-description/?&risk_analysis_description_id=${this.riskAnalysisDescriptionId}`,
          )
          .then(({ data }) => {
            this.riskAnalysis = data
            this.services = data.action_plan_services.map(service => service.type)
          })
          .catch((error) => {
            console.log(error)
          })
          .finally(() => (this.loading = false))
      },

      print() {
          window.print()
      },
    },
    mounted() {
      this.load()
    },
  }
</script>

<style lang="scss" scoped>
  .form-item-holder {
    position: relative;

    .loading-panel {
      position: absolute;
      top: 0;
      left: 0;

      height: 100%;
      width: 100%;

      background-color: #e9ecef;

      display: flex;
      align-items: center;
      justify-content: center;

      opacity: 0.9;
    }
  }

  .form {
    break-inside: avoid;
    page-break-after: always;
  }
</style>
